import { createBrowserRouter, Navigate } from 'react-router-dom';
import { publicRoutes } from './publicRoutes';
import { privateRoutes } from './privateRoutes';
import { SuspenseWrapper } from './SuspenseWrapper';
import { RouteErrorBoundary } from './RouteErrorBoundary';
import { NotFound } from '../pages/Public/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
    errorElement: <RouteErrorBoundary />,
  },
  ...publicRoutes.map(route => ({
    ...route,
    element: <SuspenseWrapper>{route.element}</SuspenseWrapper>,
    errorElement: <RouteErrorBoundary />,
  })),
  ...privateRoutes.map(route => ({
    ...route,
    children: route.children?.map(child => ({
      ...child,
      element: child.element ? <SuspenseWrapper>{child.element}</SuspenseWrapper> : child.element
    })),
    errorElement: <RouteErrorBoundary />,
  })),
  {
    path: '*',
    element: <NotFound />,
    errorElement: <RouteErrorBoundary />,
  },
]);
